/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="77.85"
        height="95.59"
        viewBox="0 0 77.85 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M26.15 8.89a11 11 0 0 1 10.93 10.62v6.43a1.25 1.25 0 0 1-2.49.13v-6.24a8.44 8.44 0 1 0-16.87 0 1.25 1.25 0 0 1-2.5 0A11 11 0 0 1 26.15 8.89ZM9.83 72.78a1.25 1.25 0 0 1 1.25 1.25 10.22 10.22 0 0 0 9.9 10.18h5.17a8.33 8.33 0 0 0 4.8-1.51 1.25 1.25 0 0 1 1.43 2 10.82 10.82 0 0 1-5.83 2h-5.29A12.71 12.71 0 0 1 8.58 74.02a1.25 1.25 0 0 1 1.25-1.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M19.4 77.61a1.25 1.25 0 1 1 0 2.5 3.34 3.34 0 0 0-3.33 3.33 1.25 1.25 0 0 1-2.5 0 5.84 5.84 0 0 1 5.83-5.83ZM13.86 58.79a1.25 1.25 0 0 1 .13 2.49h-3.58a5.41 5.41 0 0 0-.21 10.81h11.41a1.25 1.25 0 0 1 .13 2.49H10.41a7.91 7.91 0 0 1-.24-15.82h3.69Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M10.77 46.24a1.25 1.25 0 0 1 .13 2.49H7.5a5.001 5.001 0 0 0-.21 10h6.55a1.25 1.25 0 0 1 .13 2.49H7.5a7.53 7.53 0 0 1-.24-15h3.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M15.27 31.6a1.25 1.25 0 0 1 .13 2.49h-5.2a6.07 6.07 0 0 0-.23 12.13h.8a1.25 1.25 0 0 1 .13 2.49h-.7a8.571 8.571 0 0 1-.26-17.14h5.33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M21.8 18.82a7.67 7.67 0 0 1 7.64 7.69 1.25 1.25 0 0 1-2.5 0 5.16 5.16 0 0 0-4.93-5.13h-6.74a5.14 5.14 0 1 0 0 10.28 1.25 1.25 0 1 1 0 2.5 7.64 7.64 0 0 1-.25-15.27h6.78ZM51.7 8.89a11 11 0 0 1 10.94 10.94 1.25 1.25 0 1 1-2.5 0A8.42 8.42 0 0 0 46.5 13.2a1.265 1.265 0 1 1-1.55-2 10.9 10.9 0 0 1 6.75-2.31ZM42.02 66.93a1.25 1.25 0 0 1 1.24 1.12v7.72a8.47 8.47 0 0 0 8.24 8.44h5.1a10.22 10.22 0 0 0 10.18-10.18 1.25 1.25 0 0 1 2.5 0A12.73 12.73 0 0 1 56.9 86.71h-5.2a11 11 0 0 1-10.93-10.65v-7.88a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M58.5 77.61a5.85 5.85 0 0 1 5.84 5.83 1.25 1.25 0 0 1-2.5 0 3.35 3.35 0 0 0-3.34-3.33 1.25 1.25 0 0 1 0-2.5ZM67.44 58.79a7.91 7.91 0 0 1 .25 15.81H56.24a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h11.32a5.411 5.411 0 0 0 .22-10.82h-3.67a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h3.57Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M70.33 46.24a7.52 7.52 0 0 1 .24 15h-6.58a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h6.46a5.001 5.001 0 0 0 .22-10h-3.47a1.25 1.25 0 0 1-1.25-1.23 1.27 1.27 0 0 1 1.13-1.25h3.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M67.65 31.6a8.57 8.57 0 0 1 .26 17.13h-.83a1.25 1.25 0 0 1-1.25-1.22 1.27 1.27 0 0 1 1.13-1.25h.69a6.071 6.071 0 0 0 .23-12.14h-5.29a1.256 1.256 0 0 1-.09-2.51h5.19Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M62.59 18.82a7.64 7.64 0 0 1 0 15.28 1.25 1.25 0 0 1 0-2.5 5.14 5.14 0 0 0 .21-10.27h-6.74a5.16 5.16 0 0 0-5.14 5.18 1.25 1.25 0 0 1-2.5 0 7.65 7.65 0 0 1 7.39-7.63h6.78Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m49.11 1.51-7.56 38.42 15.46-5.33a1.25 1.25 0 0 1 1.58 1.61v.11L30.71 94.88a1.25 1.25 0 0 1-2.38-.65v-.13l8.26-42L21 58.56a1.25 1.25 0 0 1-1.65-1.59v-.11L46.76.71a1.25 1.25 0 0 1 2.37.66Zm-4.3 8.92L23.09 54.99l14.72-6.11a1.25 1.25 0 0 1 1.69 1.28v.12l-6.77 34.53 22.28-46.88-14.7 5.08a1.25 1.25 0 0 1-1.65-1.31v-.12Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'BrainWithLightningBoltIcon';

export default Icon;
